export const getPaymentsPlatformQueryKey = (...keys: any[]) => {
  return ['payments-platform', ...keys];
};
